import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const CaretDown = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-caret-down">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        />
    </AccentedSvgIcon>
);
